import { useContext } from 'react';
import AddonContext from '../../../../shared/components/utils/context/addonContext';
import DetailAddonAnimatableContainer from '../../atoms/container/detailAddonAnimatableContainer';
import DetailAddonInfoChannel from '../../atoms/text/detailAddonInfoChannel';
import DetailAddonInfoChannels from '../../atoms/text/detailAddonInfoChannels';
import DetailAddonInfoName from '../../atoms/text/detailAddonInfoName';
import DetailAddonInfoRightContainer from '../../atoms/container/detailAddonRightContainer';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import DetailAddonAnimatableText from '../../atoms/text/detailAddonAnimatableText';

const CHARS_TO_SCROLL = 28;
const SPACE_RATIO = 3;

function DetailAddonInfoRight() {
  const { addon, channels } = useContext(AddonContext);
  return (
    <DetailAddonInfoRightContainer>
      <DetailAddonInfoName>
        <b>{TranslationManager.get('PAGES.ADDON.ORIGINAL_TITLE')}</b>{' '}
        {addon?.title}
      </DetailAddonInfoName>
      <DetailAddonInfoChannels>
        {channels?.map((ch) => {
          const scroll = (ch?.title?.length || 0) > CHARS_TO_SCROLL;
          return (
            <DetailAddonInfoChannel key={ch.id}>
              {scroll ? (
                <DetailAddonAnimatableContainer key={ch.id} ratio={SPACE_RATIO}>
                  <DetailAddonAnimatableText>
                    {ch.title}
                  </DetailAddonAnimatableText>
                  <DetailAddonAnimatableText hide={true}>
                    {ch.title.slice(0, ch.title.length / SPACE_RATIO)}
                  </DetailAddonAnimatableText>
                  <DetailAddonAnimatableText>
                    {ch.title}
                  </DetailAddonAnimatableText>
                </DetailAddonAnimatableContainer>
              ) : (
                <>{ch.title + ' '}</>
              )}
            </DetailAddonInfoChannel>
          );
        })}
      </DetailAddonInfoChannels>
    </DetailAddonInfoRightContainer>
  );
}

export default DetailAddonInfoRight;
